// extracted by mini-css-extract-plugin
export default {"titleCard":"CardTitle_titleCard__+H5jg"};